export { default as ChakraNextImage } from "./ChakraNextImage";
export { default as ChakraNextImageV2 } from "./ChakraNextImageV2";
